//i18n-setup.js
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import vi_lang from '@/locales/vi.json'
import en_lang from '@/locales/en.json'
Vue.use(VueI18n)
export const i18n = new VueI18n({
  locale: 'vi', // set locale
  fallbackLocale: 'vi',
  messages: {
    en: en_lang,
    vi: vi_lang
  }
})